import { Component, Input, output } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';
import { InputV2Module } from '@schenck/rotec-components';

@Component({
  selector: 'ma-scheduling-daily',
  templateUrl: './scheduling-daily.component.html',
  styleUrls: ['./scheduling-daily.component.less', '../scheduling-interval.less'],
  imports: [TranslateDirective, InputV2Module],
})
export class SchedulingDailyComponent {
  @Input()
  public interval = 1;
  public readonly intervalChange = output<number>();

  public changeInterval(interval: string): void {
    this.intervalChange.emit(Number(interval));
  }
}
